module.exports = __webpack_public_path__ + "img/인플레이아이콘.1bbe1809.png";